module.exports = __webpack_public_path__ + "static/media/gant_thumb.e3c16dfe.jpg";